import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M19.24 19.25H4V4h11.428v1.906H5.906v11.438h11.428v-4.766h1.907v6.672z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "m13.293 10.793 7-7 1.414 1.414-7 7-1.414-1.414z",
		clipRule: "evenodd"
	})]
});
export default SvgCustomIcon;
